import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {  getPostData,
    getPostDataCancelToken,
    resetPublicView } from '../../../actions/publicView/view';
import LoginForm from '../Login/LoginForm';
import SharedCard from '../../loggedIn/Feed/cards/SharedCard';
import { getASharedPost } from '../../../actions/publicView/shared';
import { miscLinks } from '../../../utils/internalLinks';
import SeoHeadMeta from '../../../components/misc/SeoHeadMeta';
import { decodeString } from '../../../utils/helper';

function PostView(props) {
    const [showLoginForm, setShowLoginForm] = useState(false);
    const { match: { params: { id, type, postid } } } = props;
    let typeToRequest = type === 'collaborations'
            ? 'collaborate'
            : type;
    useEffect(() => {
        props.getASharedPost(id,
            typeToRequest,
            postid)
        .then(val => {
            // Take it to 404 if not found
            if(!val) {
                props.history.replace(miscLinks.notFound);
            }
        });
        return function cleanup() {
            if (getPostDataCancelToken) getPostDataCancelToken();
            props.resetPublicView();
        }
    }, [props.match.params.id]);

    return (<div className="container detail-page detail-page--with-height">
        { props.publicView
            && props.publicView.viewData
            && props.publicView.viewData.seoTags
            && props.publicView.viewData.seoTags.title
            && <SeoHeadMeta title={props.publicView.viewData.seoTags.title}>
                <title>{decodeString(props.publicView.viewData.seoTags.title)}</title>
            </SeoHeadMeta>}
        {
            props.publicView.fetching
            ? <p>Fetching...</p>
            : props.publicView.viewData
              && props.publicView.viewData.type
            ? (<>
            <div className="detail-page__card">
                <SharedCard
                    publicClickAction={() => setShowLoginForm(true)}
                    cardData={props.publicView.viewData}
                    isPublic={true}
                    isDetailsPage={true}
                    autoFocusComments={false} />
            </div>
            </>)
            : null
        }
        { showLoginForm && <LoginForm shouldOnlyToggle={true}
            toggleLoginForm={() => setShowLoginForm(false)} /> }
    </div>)
};

function mapStateToProps(state) {
    return {
        publicView: state.publicView
    }
}

const mapDispatchToProps = {
    getPostData,
    resetPublicView,
    getASharedPost
}

export default connect(mapStateToProps, mapDispatchToProps)(PostView);